module.exports = __webpack_public_path__ + "img/banner.d8cdb9a3.png";